import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { DonutChart as Donut } from '@atlassian/viz-platform-charts--next/charts';
import { element, useElementProps } from '@atlassian/viz-platform-charts--next/core';

type DonutChartData = {
	label: string;
	value: number;
};

type DonutChartProps = {
	children?: React.ReactNode;
	data: DonutChartData[];
};

const CustomLayout: React.FC<{ gridTemplate: string[] }> = element(
	() => {
		const { children } = useElementProps(Donut.elements.Layout);

		return (
			<Box data-element="layout" xcss={donutLayoutStyles}>
				<Box data-element="chart" xcss={donutChartStyles}>
					{children}
				</Box>
			</Box>
		);
	},
	{ as: Donut.elements.Layout },
);

export const DonutChart = ({ children, data }: DonutChartProps) => {
	return (
		<Donut
			data={data}
			labelAccessor={(d) => d.label}
			valueAccessor={(d) => d.value}
			colorAccessor={(d) => d.label}
		>
			{/* the gridTemplate prop value enables the vertical legend */}
			<CustomLayout gridTemplate={['plot']} />
			<Donut.elements.Legend shape="square" />
			{children}
		</Donut>
	);
};

const donutLayoutStyles = xcss({
	flexGrow: '1',
	overflow: 'hidden',
	paddingTop: 'space.075',
	paddingBottom: 'space.075',
	marginRight: 'space.negative.150',
});

const donutChartStyles = xcss({
	display: 'flex',
	flexDirection: 'row-reverse',
	height: '100%',
});
